import { getGlsBaseUrl } from '@/api/gls/get-gls-base-url';

/**
 * Builds the FGP update-geolocation-token endpoint from the region-aware GLS
 * base (same host resolution as {@link getNetPositionEndpoint}). Returns `null`
 * when no GLS base is configured so callers treat it as a skipped call.
 *
 * Mirrors casino-game-client's `${config.fgp.FGPUpdatePath}/geolocationToken`
 * (PUT) — game-window has no dedicated FGP config key, so the path suffix is
 * appended to the GLS base the same way net-position does.
 */
export const getUpdateGeolocationTokenEndpoint = (): string | null => {
  let base: string;

  try {
    base = getGlsBaseUrl();
  } catch {
    return null;
  }

  if (!base) {
    return null;
  }

  const trimmedBase = base.endsWith('/') ? base.slice(0, -1) : base;

  return `${trimmedBase}/cfg/api/v1/update/geolocationToken`;
};
